import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(key, { ns: "validation" });

export const medicalRecordSchema = z.object({
  pet_id: z.string().uuid(t("selectPatient")),
  appointment_id: z.string().uuid().optional().or(z.literal("")),
  clinic_id: z.string().uuid(t("clinicRequired")),
  consultation_date: z.date({
    required_error: t("consultationDateRequired"),
  }),
  
  // Anamnese (todos opcionais)
  chief_complaint: z.string().optional().or(z.literal("")),
  history: z.string().optional().or(z.literal("")),
  behavior: z.string().optional().or(z.literal("")),
  diet: z.string().optional().or(z.literal("")),
  environment: z.string().optional().or(z.literal("")),
  
  // Exame Físico (todos opcionais)
  weight: z.number().positive(t("weightPositive")).max(10000, t("weightMax")).optional(),
  temperature: z.number().optional(),
  heart_rate: z.number().int().positive().optional(),
  respiratory_rate: z.number().int().positive().optional(),
  mucous_membranes: z.string().optional().or(z.literal("")),
  capillary_refill_time: z.string().optional().or(z.literal("")),
  hydration_status: z.string().optional().or(z.literal("")),
  lymph_nodes: z.string().optional().or(z.literal("")),
  cardiac_auscultation: z.string().optional().or(z.literal("")),
  respiratory_auscultation: z.string().optional().or(z.literal("")),
  abdominal_palpation: z.string().optional().or(z.literal("")),
  locomotor_system: z.string().optional().or(z.literal("")),
  skin_coat: z.string().optional().or(z.literal("")),
  other_systems: z.string().optional().or(z.literal("")),
  
  // Diagnóstico (todos opcionais)
  presumptive_diagnosis: z.string().optional().or(z.literal("")),
  definitive_diagnosis: z.string().optional().or(z.literal("")),
  
  // Tratamento (todos opcionais)
  treatment: z.string().optional().or(z.literal("")),
  
  // Retorno (todos opcionais)
  follow_up_date: z.date().optional(),
  follow_up_notes: z.string().optional().or(z.literal("")),
  register_death: z.boolean().optional(),
  death_date: z.date().optional(),
  death_cause: z.string().optional().or(z.literal("")),
}).superRefine((data, ctx) => {
  if (data.register_death && !data.death_date) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["death_date"],
      message: t("deathDateRequired"),
    });
  }
});

export type MedicalRecordInput = z.infer<typeof medicalRecordSchema>;

export type MedicalRecordFormInput = MedicalRecordInput & {
  create_follow_up_appointment?: boolean;
  follow_up_time?: string;
};
